import { createRouter, createWebHashHistory } from 'vue-router'
import LoginPage from "../views/login/login";
import DashboardPage from "../views/dashboard";

const routes = [
  {
    path: '/',
    name: 'DashboardPage',
    component: DashboardPage,
    meta:{
      title:'管理首页'
    }
  },
  {
    path: '/login',
    name: 'LoginPage',
    hidden:true,
    component: LoginPage,
    meta:{
      title:'登录'
    }
  }
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})
export default router
